import { render } from "./appointmentTermination.vue?vue&type=template&id=2c138cae&scoped=true"
import script from "./appointmentTermination.vue?vue&type=script&lang=ts"
export * from "./appointmentTermination.vue?vue&type=script&lang=ts"

import "./appointmentTermination.vue?vue&type=style&index=0&id=2c138cae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c138cae"

export default script